/* Auto-Created File, Do not edit directly. */
export const apiURI="https://api.playin.com.tr";
